import { FC } from 'react';

import styled from 'styled-components';

import { SolicitacaoDetalhada } from 'model/solicitacao/SolicitacaoDetalhada';
import { useFormularioContext} from 'view/component/Formulario/Formulario';
import { TempoAtras } from 'view/component/Tempo/TempoAtras';
import { TextoPequeno } from 'view/component/Tipografia/Texto';
import { NomePessoa } from 'view/component/Pessoa/NomePessoa';

import { Spacing } from 'styles/theme/Tema';
import { OperacaoFormularioCRUD } from 'service/restricao/OperacaoFormulario/OperacaoFormulario';


interface InformacoesPersistenciaProps {
  solicitacao?: SolicitacaoDetalhada
}

export const InformacoesPersistencia: FC<InformacoesPersistenciaProps> = ({solicitacao}) => {
  const contexto = useFormularioContext()

  if (contexto.operacao !== OperacaoFormularioCRUD.Visualizar || contexto.carregando || solicitacao === undefined) {
    return <></>
  }

  return <InformacoesPersistenciaContainer>
    {solicitacao?.dataCriacao && 
      <InformacaoPersistencia as="div">
        Criado <TempoAtras data={solicitacao.dataCriacao} />
        {' '} por <NomePessoa tipo='span' idInstitucional={solicitacao.idCriador!!} />
      </InformacaoPersistencia>}
    {solicitacao?.dataAtualizacao && <InformacaoPersistencia as="div">Última atualização na solicitação <TempoAtras data={solicitacao.dataAtualizacao} /></InformacaoPersistencia>}
  </InformacoesPersistenciaContainer>
}

const InformacoesPersistenciaContainer = styled.div`
  margin-top: ${Spacing.unit}px;
  padding-top: ${Spacing.unit}px;
  border-top: 1px solid ${({theme}) => theme.background.borda};
`;

const InformacaoPersistencia = styled(TextoPequeno)`
  text-align: center;
  color: ${({theme}) => theme.texto.enfase_baixa};
`;